/** Public company identity for OnTheWeb legal pages and payment-gateway review. */
export const COMPANY = {
  legalName: 'Gortnm Innovations Private Limited',
  brand: 'OnTheWeb',
  cin: 'U74999UP2020PTC128654',
  // No postal address is published on the site: support runs on phone, WhatsApp
  // and email. Invoices still carry the registered office, which is set on the
  // server (src/config/billing.ts) since a tax invoice has to show it.
  phone: '+91 92581 01930',
  phoneHref: 'tel:+919258101930',
  supportEmail: 'support@ontheweb.ai',
  legalEmail: 'legal@ontheweb.ai',
  siteUrl: 'https://business.ontheweb.ai',
  productUrl: 'https://ontheweb.ai',
  grievanceOfficer: 'Atul Goel, Director',
  governingLaw: 'the laws of India',
  jurisdiction: 'the courts at Meerut, Uttar Pradesh, India',
  effectiveDate: '29 September 2026',
} as const;

/**
 * OnTheWeb's own profiles, in the order they appear in the footer. `icon` selects
 * the glyph in src/components/SocialLinks.tsx, and the same URLs are the
 * Organization's `sameAs` in public/index.html — which is how a search engine
 * ties these accounts to the brand. Keep both in step with
 * ontheweb-user-web/lib/company.ts.
 */
export const SOCIAL_LINKS = [
  { label: 'YouTube', icon: 'youtube', url: 'https://www.youtube.com/@OnTheWeb_AI' },
  { label: 'Instagram', icon: 'instagram', url: 'https://www.instagram.com/ontheweb.ai/' },
  { label: 'Facebook', icon: 'facebook', url: 'https://www.facebook.com/profile.php?id=61594335363651' },
  { label: 'LinkedIn', icon: 'linkedin', url: 'https://www.linkedin.com/company/ontheweb-ai' },
] as const;

export const LEGAL_PATHS = {
  terms: '/terms-and-conditions',
  privacy: '/privacy-policy',
  cookies: '/cookie-policy',
  refunds: '/refund-and-cancellation-policy',
} as const;

export const CONTACT_PATH = '/contact-us';

/** Plain-language page listing what a website plan does and does not include. */
export const OFFERING_PATH = '/what-you-get';
